import React, { useState } from 'react';
export var TodoHeader = function (props) {
    var _a = useState(''), labelInput = _a[0], setLabelInput = _a[1];
    var _onFilter = function (evt) {
        props.setFilter(evt.target.innerText);
    };
    var _onChange = function (evt) {
        setLabelInput(evt.target.value);
    };
    var _onAdd = function () {
        props.addTodo(labelInput);
        setLabelInput('');
    };
    return (React.createElement("header", null,
        React.createElement("h1", null, "todos"),
        React.createElement("div", { className: "addTodo" },
            React.createElement("input", { value: labelInput, onChange: _onChange, className: "textfield", placeholder: "add todo" }),
            React.createElement("button", { onClick: _onAdd, className: "submit" }, "Add")),
        React.createElement("nav", { className: "filter" },
            React.createElement("button", { onClick: _onFilter, className: props.filter === 'all' ? 'selected' : '' }, "all"),
            React.createElement("button", { onClick: _onFilter, className: props.filter === 'active' ? 'selected' : '' }, "active"),
            React.createElement("button", { onClick: _onFilter, className: props.filter === 'completed' ? 'selected' : '' }, "completed"))));
};
